import { mapGetters } from 'vuex';
import lodash from 'lodash';
import healthInsuranceProvidersBenefits from '/public/healthInsuranceProvidersBenefits';

export default {
  computed: {
    ...mapGetters({
      insuranceCompanyList: 'forms/insuranceCompany/insuranceCompanyList'
    }),
    hasBenefits() {
      return !lodash.isEmpty(this.currentProviderBenefitsData);
    },
    currentProvider() {
      return this.$auth.user.healthInsuranceCompany
        ? this.insuranceCompanyList.find(val => val.id === this.$auth.user.healthInsuranceCompany)
        : null;
    },
    currentProviderBenefitsData() {
      return lodash.isEmpty(this.currentProvider)
        ? []
        : healthInsuranceProvidersBenefits.find(
            val => val.slug === this.currentProvider.additionalInfo.slug
          );
    }
  }
};
